import React from "react";

const Logo = () => {
  return (
      <div style={{width: '100%', display: "flex", justifyContent: 'center'}}>
          <img src="/icon.png" width={150} height={150} className={'logo'} alt="location tracker"/>
      </div>
  );
}

export default Logo;
